import { createContext, ReactNode, useMemo } from 'react';
import { useNotifications } from '../hooks/use-notifications';
import { Notification } from '../models/notification';

interface NotificationContext {
  list: Notification[];
  getNotifications: () => void;
  readNotifications: (ids: number[]) => void;
  setNotifications: (
    list: Notification[] | ((prev: Notification[]) => Notification[]),
  ) => void;
  page: number;
  hasMore: boolean;
  loadingMore: boolean;
  loadMore: () => Promise<void>;
}

export const NotificationContext = createContext<NotificationContext>({
  list: [],
  getNotifications: () => {},
  readNotifications: () => {},
  setNotifications: () => {},
  page: 1,
  hasMore: true,
  loadingMore: false,
  loadMore: async () => {},
});

const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const {
    listNotifications,
    setNotificationsReaded,
    notifications,
    set,
    page,
    hasMore,
    loadingMore,
    loadMore,
  } = useNotifications();

  const value = useMemo(
    () => ({
      list: notifications,
      getNotifications: listNotifications,
      readNotifications: setNotificationsReaded,
      setNotifications: set,
      page,
      hasMore,
      loadingMore,
      loadMore,
    }),
    [
      notifications,
      listNotifications,
      setNotificationsReaded,
      set,
      page,
      hasMore,
      loadingMore,
      loadMore,
    ],
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
